import React from 'react';
import { useTranslation } from 'react-i18next';

import { Colors, Icons } from '@kp/react-ui';

import type { AppAccess } from '../../types/home-types';
import { InstalledAppCard } from '../InstalledAppCard';

export type ConnectAppCardProps = AppAccess;

export const ConnectAppCard: React.FC<ConnectAppCardProps> = (access) => {
  const { t } = useTranslation();

  return (
    <InstalledAppCard
      icon={Icons.IconDashboard}
      iconColor={Colors.Palette.green}
      title={t('home.apps.connect.title')}
      description={t('home.apps.connect.description')}
      {...access}
    />
  );
};
